/**
 * Helpers partagés pour AdminImmeublePortalMirror : PanelTitle, EmptyState, ClickableStat.
 *
 * Extrait de AdminImmeublePortalMirror.jsx (Batch #14.221).
 */


function PanelTitle({ icon: Icon, label, count, tone = "indigo", inline = false }) {
  const tones = {
    indigo: "text-indigo-700",
    rose: "text-rose-700",
    emerald: "text-emerald-700",
    amber: "text-amber-700",
  };
  if (inline) {
    return (
      <h4 className={`text-xs font-bold uppercase tracking-wider inline-flex items-center gap-2 ${tones[tone]}`}>
        <Icon className="w-4 h-4" /> {label}
        <span className="text-[11px] text-slate-500 font-semibold normal-case ml-1">({count})</span>
      </h4>
    );
  }
  return (
    <div className="flex items-center justify-between mb-3">
      <h4 className={`text-xs font-bold uppercase tracking-wider inline-flex items-center gap-2 ${tones[tone]}`}>
        <Icon className="w-4 h-4" /> {label}
      </h4>
      <span className="text-[11px] text-slate-500 font-semibold">{count} élément(s)</span>
    </div>
  );
}

function EmptyState({ label }) {
  return <div className="text-xs text-slate-400 italic text-center py-4">{label}</div>;
}

function ClickableStat({ icon: Icon, label, value, sub, accent, active, onClick, testId }) {
  const accents = {
    indigo:  { iconBg: "bg-indigo-100 text-indigo-700",  ring: "ring-indigo-400 border-indigo-400" },
    emerald: { iconBg: "bg-emerald-100 text-emerald-700", ring: "ring-emerald-400 border-emerald-400" },
    blue:    { iconBg: "bg-blue-100 text-blue-700",       ring: "ring-blue-400 border-blue-400" },
    rose:    { iconBg: "bg-rose-100 text-rose-700",       ring: "ring-rose-400 border-rose-400" },
    amber:   { iconBg: "bg-amber-100 text-amber-700",     ring: "ring-amber-400 border-amber-400" },
    slate:   { iconBg: "bg-slate-100 text-slate-500",     ring: "ring-slate-300 border-slate-400" },
  };
  const tone = accents[accent] || accents.indigo;
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      aria-pressed={active}
      className={`bg-white/80 border-2 rounded-lg p-3 flex items-center gap-3 text-left transition-all hover:shadow-md hover:scale-[1.02] active:scale-95 ${
        active ? `${tone.ring} ring-2 shadow-md` : "border-indigo-200"
      }`}
    >
      <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${tone.iconBg}`}>
        <Icon className="w-4 h-4" />
      </div>
      <div className="min-w-0">
        <div className="text-[10px] text-slate-500 truncate">{label}</div>
        <div className="text-sm font-bold text-slate-800 leading-tight tabular-nums">{value}</div>
        {sub && <div className="text-[10px] text-emerald-600 font-normal">{sub}</div>}
      </div>
    </button>
  );
}

export { PanelTitle, EmptyState, ClickableStat };
